import { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

export function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => {
      setIsOffline(false);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (isOffline) {
    return (
      <div
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-2 bg-amber-600 text-white px-4 py-2 rounded-full shadow-lg text-sm font-medium"
        data-testid="offline-indicator"
      >
        <WifiOff size={16} />
        Offline - Showing cached data
      </div>
    );
  }

  if (showReconnected) {
    return (
      <div
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-full shadow-lg text-sm font-medium animate-fade-in"
        data-testid="online-indicator"
      >
        <Wifi size={16} />
        Back online
      </div>
    );
  }

  return null;
}
